// extracted by mini-css-extract-plugin
module.exports = {"textContent":"_3uFPyd5fZEWXV9WUoOHARz","modalTitle":"_3_43Zy_-GPpEIy8KDfgTEC","kidImg":"KN9O7sm6dj-_cKUvk_Lx1"};